import { useEffect } from 'react';
import { type Control, useFormState } from 'react-hook-form';

import type { OrderFormV3FieldValues } from '../OrderFormV3Context';

/**
 * Triggers: validation errors on the tax schedule, rate or taxable scope (held on
 *           `taxFreight`).
 * Writes:   the Provider's `isTaxSectionVisible` state — opens the collapsed tax card.
 * Guards:   only opens; a cleared error leaves the card as the user left it.
 * Legacy:   none.
 * Test:     __tests__/OrderFormV3Context.test.tsx ("tax section").
 */
export function useTaxSectionErrorReveal({
  control,
  setIsTaxSectionVisible,
}: {
  control: Control<OrderFormV3FieldValues>;
  setIsTaxSectionVisible: (visible: boolean) => void;
}): void {
  const { errors } = useFormState({
    control,
    name: ['taxRateSchedule', 'taxRate', 'taxFreight'],
  });
  const hasTaxError = Boolean(
    errors.taxRateSchedule || errors.taxRate || errors.taxFreight,
  );

  useEffect(() => {
    if (hasTaxError) {
      setIsTaxSectionVisible(true);
    }
  }, [hasTaxError, setIsTaxSectionVisible]);
}
